import { ApplicationRouteURL } from './../config';
import { AuthService } from './../models/auth.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wego-privacy-not-allow',
  template: `
  <section class="content">
  <div class="col-md-12 text-center">
    <div class="panel panel-danger">
      <div class="panel-heading">
      {{ 'LblPrivacyError' | translate }}
      </div>
      <div class="panel-body">
        <p>
        {{ 'LblPrivacyErrorMessage' | translate }}
        {{ 'LblPrivacyNavigate' | translate }}&nbsp;<a [routerLink]="urlDefaultPage">{{ 'LblHome' | translate }}</a> page.
        </p>
      </div>
    </div>
    </div>
  </section>
  `,
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})
export class PrivacyNotAllowComponent implements OnInit {
  urlDefaultPage: string;
  constructor(private authService: AuthService) { }

  ngOnInit() {
    this.urlDefaultPage = this.authService.GetURL(ApplicationRouteURL.URL_DEFAULT_PAGE);
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/privacy-not-allow.component.ts